
import React from "react";
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ComposedChart,
  ResponsiveContainer,
} from "recharts";

const data = [
  { year: "2004/05", Bolivia: 300, Ecuador: 200, Rwanda: 150, Average: 500 },
  { year: "2005/06", Bolivia: 800, Ecuador: 600, Rwanda: 400, Average: 700 },
  { year: "2006/07", Bolivia: 900, Ecuador: 700, Rwanda: 500, Average: 750 },
  { year: "2007/08", Bolivia: 950, Ecuador: 720, Rwanda: 520, Average: 730 },
  { year: "2008/09", Bolivia: 850, Ecuador: 680, Rwanda: 480, Average: 710 },
];

const CoffeeChart = () => {
  return (
    <ResponsiveContainer width="100%" height={400}>
      <ComposedChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="year" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="Bolivia" fill="#0088FE" />
        <Bar dataKey="Ecuador" fill="#00C49F" />
        <Bar dataKey="Rwanda" fill="#FFBB28" />
        <Line type="monotone" dataKey="Average" stroke="red" strokeWidth={2} />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default CoffeeChart;
